
export const setUser = (state, update) => {
  const { data = null } = update;
  if (data) {
    const { token = null, idPeriodoActual = null } = data;
    if (token) {
      sessionStorage.setItem("token", token);
      sessionStorage.setItem("cuenta", update.cuenta);
      sessionStorage.setItem("idPeriodoActual", idPeriodoActual);
      //sessionStorage.setItem("idPeriodoActual", 1);

      state.token = token;
      state.cuenta = update.cuenta;
      state.idPeriodoActual = idPeriodoActual;
      //state.idPeriodoActual = 1;
    }
  }
};

export const setIsBBJ = (state,update) => {
  const {data = null} = update;
  if (data){
    state.isBBJStore = true; 
  }
}

export const setIsComunidad = (state,update) => {
  const {data = null} = update;
  if (data){
    state.isComunidadStore = true; 
  }
}

export const setIdRegistro = (state, update) => {
  const { data = null } = update;
  if (data) {
    const { token = null, idRegistro = null } = data;
    if (idRegistro) {
      sessionStorage.setItem("idRegistro", idRegistro);
      state.idRegistro = idRegistro;
    }
  }
};

export const setCuestionario = (state, respuestas) => {
  state.respuestasCuestionario = {
    ...state.respuestasCuestionario,
    ...respuestas,
  };
};

export const clearState = (state) => {
  sessionStorage.clear();
  state.idPeriodoActual = "";
  state.token = "";
  state.cuenta = "";
};

export const clearArchivos = (state) => {
  state.isBBJStore = false;
  state.isComunidadStore = false;
        
}
